import { css } from '@emotion/css';
import { Font, FontWeight } from 'src/styles';

export const viewDetailsButton = css`
  ${Font.lg}
  ${FontWeight.semibold}
  min-width: 5rem !important;
`;
